const header = () => {
	const Header = {
		init: () => {},
	};

	$(() => {
		Header.init();
	});
};

export default {
	init: header,
};



// WEBPACK FOOTER //
// ./scripts/components/header.js